// CalendlyWidget.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import FooterBlack from "./Footer";
import { usePublicLang } from "../../../config/i18n/public";

export default function CalendlyWidget() {
  const navigate = useNavigate();
  const { copy } = usePublicLang();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/landingpage");
    }
  };

  return (
    <section className="w-full bg-white text-[#0b1b2d]">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 py-6 sm:py-12 relative">
        {/* Back button (bigger tap target on mobile) */}
        <button
          onClick={handleBack}
          className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-[#f3f4f6] px-3 py-2 sm:px-4 sm:py-2 text-sm font-medium text-[#0b1b2d] shadow hover:bg-[#e5e7eb] transition"
        >
          {copy.calendly.back}
        </button>

        {/* Card wrapper: full width on mobile, constrained on larger screens */}
        <div className="mx-auto mt-16 sm:mt-12 w-full max-w-md sm:max-w-xl md:max-w-3xl rounded-2xl shadow-lg ring-1 ring-black/10 overflow-hidden">
          <iframe
            title="Calendly Scheduling"
            src="https://calendly.com/contact-stefficare/30min"
            className="
              w-full
              h-[70vh]           /* tall enough on small phones */
              sm:h-[650px]       /* Calendly recommends ~630–680px */
              md:h-[720px]
            "
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      <FooterBlack />
    </section>
  );
}
